export const queryKeys = {
  accountBalances: {
    all: ["accountBalances"] as const,
    byAddress: (address: string) => [...queryKeys.accountBalances.all, address] as const,
  },
  accountAllowances: {
    all: ["accountAllowances"] as const,
    byAddress: (address: string) => [...queryKeys.accountAllowances.all, address] as const,
  },
  actionsList: {
    all: ["actionsList"] as const,
    byView: (address: string, type: string) =>
      [...queryKeys.actionsList.all, address, type] as const,
  },
  safes: {
    all: ["safes"] as const,
    lists: () => [...queryKeys.safes.all, "list"] as const,
    list: (address: string) => [...queryKeys.safes.lists(), address] as const,
  },
  lightUserSnapshot: {
    all: ["lightUserSnapshot"] as const,
    byAddress: (address: string) => [...queryKeys.lightUserSnapshot.all, address] as const,
  },
  userSnapshot: {
    all: ["userSnapshot"] as const,
    byAddress: (address: string) => [...queryKeys.userSnapshot.all, address] as const,
  },
  helperSnapshot: {
    all: ["helperSnapshot"] as const,
    byAddress: (address: string) => [...queryKeys.helperSnapshot.all, address] as const,
  },
  trustors: {
    all: ["trustors"] as const,
    byAddress: (address: string) => [...queryKeys.trustors.all, address] as const,
  },
  trustor: {
    all: ["trustor"] as const,
    byAddress: (address: string) => [...queryKeys.trustor.all, address] as const,
  },
  userByName: {
    all: ["userByName"] as const,
    byName: (name: string) => [...queryKeys.userByName.all, name] as const,
  },
  userEmail: {
    all: ["userEmail"] as const,
    byAddress: (address: string) => [...queryKeys.userEmail.all, address] as const,
  },
  fetchPolicies: {
    all: ["fetchPolicies"] as const,
    byGroup: (safeAddress: string, groupId: string) =>
      [...queryKeys.fetchPolicies.all, safeAddress, groupId] as const,
  },
  lightSafeSnapshot: {
    all: ["lightSafeSnapshot"] as const,
    byAddress: (address: string) => [...queryKeys.lightSafeSnapshot.all, address] as const,
  },
  modal: {
    lightUserSnapshot: (address: string) => ["modalLightUserSnapshot", address] as const,
    user: (name: string) => ["modalUser", name] as const,
  },
  addressBook: {
    all: ["addressBook"] as const,
    bySafe: (safeAddress: string) => [...queryKeys.addressBook.all, safeAddress] as const,
    byId: (id: string) => [...queryKeys.addressBook.all, "contact", id] as const,
  },
} as const;
